import { render, staticRenderFns } from "./awardinfo.vue?vue&type=template&id=7bb276ad&scoped=true&"
import script from "./awardinfo.vue?vue&type=script&lang=js&"
export * from "./awardinfo.vue?vue&type=script&lang=js&"
import style0 from "./awardinfo.vue?vue&type=style&index=0&id=7bb276ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb276ad",
  null
  
)

export default component.exports